export default "__VITE_ASSET__59b804d5__"